import { range } from 'lodash-es';
import Skeleton from 'react-loading-skeleton';
import styles from '../Table.module.scss';

interface LoadingRowsProps {
  pageSize: number;
  columnCount: number;
}

const LoadingRows = ({ pageSize, columnCount }: LoadingRowsProps) => (
  <>
    {range(pageSize).map(i => (
      <tr key={i}>
        <td className={styles.loading} colSpan={columnCount}>
          <Skeleton height={30} />
        </td>
      </tr>
    ))}
  </>
);

export default LoadingRows;
